import React from 'react';
import { cn } from '../../lib/utils.js';

export function Button({ className, variant = 'primary', size = 'md', children, ...props }) {
  const variants = {
    primary: 'bg-slate-900 text-white hover:bg-slate-800',
    secondary: 'bg-white text-slate-900 hover:bg-slate-50 border border-slate-200',
    outline: 'bg-transparent text-white border border-white/30 hover:bg-white/10',
    blue: 'bg-blue-600 text-white hover:bg-blue-700',
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-semibold',
  };

  return (
    <button
      className={cn(
        'inline-flex items-center justify-center rounded-none transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function Section({ className, children, id, dark = false, airy = true, padding = 'default' }) {
  const paddings = {
    default: 'py-24 md:py-32',
    compact: 'py-12 md:py-16',
    none: 'py-0',
  };

  return (
    <section
      id={id}
      className={cn(
        paddings[padding] || (airy ? paddings.default : paddings.compact),
        dark ? 'bg-slate-900 text-white' : 'bg-white text-slate-900',
        className
      )}
    >
      <div className="container mx-auto px-4 md:px-6">
        {children}
      </div>
    </section>
  );
}
